import React from 'react';
import PropTypes from 'prop-types';

export const AddTileToDigestTile = ({ onClick }) => {
  return (
    <div className="tile_container">
      <div className="add-move-tile columns large-4" onClick={onClick}>
        <div className="fa-solid fa-plus" />
        <div>Add or Drag a Tile</div>
      </div>
    </div>
  );
};

AddTileToDigestTile.propTypes = {
  onClick: PropTypes.func.isRequired,
};
